import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { UsersService } from '../_services/users.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { ConfirmationService, MessageService } from 'primeng/api';
import { LoginService } from '../../login/login.service';
import { RolesService } from '../../roles/_services/roles.service';
import { ContractsService } from '../../companies/_services/contracts.service';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';
import { LocalStorageService } from 'angular-web-storage';

@Component({
    selector: 'app-users-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['./users-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'list-page' },
    standalone: false
})
export class UsersListComponent implements OnInit {

  public users: any[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = this.getDefaultFilters();
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public activeOptions: any[] = [
    { id: null, name: 'Todos' },
    { id: true, name: 'Activos' },
    { id: false, name: 'Inactivos' }
  ];
  public absenceOptions: any[] = [
    { id: null, name: 'Todos' },
    { id: true, name: 'Ausentes' },
    { id: false, name: 'No ausentes' }
  ];
  public roles: any[] = [];
  public isList: boolean = true;
  public isTeamLeader: boolean = true;

  public teamChip: Filter = new Filter(FilterOperation.equals, 'isList', '', true);
  public roleOptions: { label: string; value: any }[] = [];
  public fieldsConfig: FilterFieldConfig[] = [
    { filter: this.filters.name, type: 'text', label: 'Nombre', base: true },
    { filter: this.filters.roleId, type: 'select', label: 'Rol', options: this.roleOptions, filterable: true, base: true },
    { filter: this.filters.active, type: 'select', label: 'Estado', options: [{ label: 'Activos', value: true }, { label: 'Inactivos', value: false }], base: true },
    { filter: this.filters.absence, type: 'select', label: 'Ausencia', options: [{ label: 'Ausentes', value: true }, { label: 'No ausentes', value: false }], base: true },
    { filter: this.teamChip, type: 'bool', label: 'Solo mi equipo', base: true }
  ];

  constructor(
    private usersService: UsersService,
    private router: Router,
    public topbarService: TopbarService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loginService:LoginService,
    private rolesService: RolesService,
    private contractService: ContractsService,
    private storage: LocalStorageService
  ) {  
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Usuarios");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({});
    });
    this.allowWrite = this.loginService.hasPermission("USERS.WRITE");
    this.allowDelete = this.loginService.hasPermission("USERS.DELETE");
    this.loadRoles();
    this.getContractsForKnowingIfIsTeamLeader();
  }

  getDefaultFilters() {
    return {
      name: new Filter(FilterOperation.contains, 'name'),
      isWorker: new Filter(FilterOperation.equals, 'isWorker', "", false),
      active: new Filter(FilterOperation.equals, 'active', "", true),
      absence: new Filter(FilterOperation.equals, 'absence', ""),
      roleId: new Filter(FilterOperation.equals, 'roleId', ""),
     // isList: new Filter(FilterOperation.equals, 'isList', "", true)
    };
  }

  async loadRoles() {
    let response = await firstValueFrom(this.rolesService.all());
    this.roles = response.data;
    this.roleOptions.length = 0;
    this.roleOptions.push(...response.data.map((r: any) => ({ label: r.title, value: r.id })));
  }

  async getContractsForKnowingIfIsTeamLeader(){
    //no parece que en los roles tengan permiso. Me voy a ahorrar esta petición. Si tienen acceso ven la opción y fiesta.
    /*let user = this.storage.get('user');
    let filters: any = {
      responsibleUserId: new Filter(FilterOperation.equals, "responsibleUserId",'',user.id),
    };
     let params:IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.contractService.all(params));
    this.isTeamLeader = response.meta["total"] > 0 ? true : false;*/

  }

  async loadData($event: any) {

    this.lastGridEvent = $event;
    this.isList = this.teamChip.value === true;

   this.filters.isWorker =  new Filter(FilterOperation.equals, 'isWorker', "", false);
    let params: IParamsCollection = {
      include: ['role'],
      sort: ['name'],
      page: { number: $event.first + 1, size: $event.rows },      
      custom: { isList: this.isList }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();
    //params.filter = params.filter+ "?isList=true";
    let response = await firstValueFrom(this.usersService.all(params, false, true));
    this.users = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  /*
  clearFilters() {
    this.filters = this.getDefaultFilters();
    this.search();
  }
  */

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(user: any) {
    this.router.navigate(['users/' + (user && Object.keys(user).length > 0 ? user.id : 0)]);
  }

  delete(user: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el usuario?",
        header: "Eliminar usuario",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.usersService.delete(user.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Usuario eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }

  async setAusence(user: any) {

    await this.usersService.save(user).subscribe({
      next: (data) => {
        this.messageService.add({ closable: true, severity: 'success', detail: "Ausencia actualizada correctamente." });
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  async setActive(user: any) {

    await this.usersService.save(user).subscribe({
      next: (data) => {
        this.messageService.add({ closable: true, severity: 'success', detail: "Estado del usuario actualizado correctamente." });
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

}
